export default "__VITE_ASSET__L4J5EhC8__"